module.exports = __webpack_public_path__ + "static/img/icon1.0bf6e30e.png";